import { createSlice } from "@reduxjs/toolkit";

const fileSlice = createSlice({
    name: "file",
    initialState: {
        uploading: ""
    },
    reducers: {
        uploadFiles: (state, action) => {
            //console.log(action.payload.data.name)
            state.uploading = action.payload.data.name;
        },
        replaceFiles: (state, action) => {
            //console.log(action.payload.data.name)
            state.uploading = action.payload.data.name;
        },
        fileUploaded: (state) => {
            state.uploading = ""
        },
        deleteFile:(state)=>{
            state.uploading=""
        }
    }
})

export const { uploadFiles, fileUploaded ,deleteFile,replaceFiles} = fileSlice.actions
export const filesLoadingSelector = state => state.files.uploading
export default fileSlice.reducer